import { usePermissions } from "../../hooks/usePermissions";
import styled from "styled-components";
import { Switch } from "@monolith-forensics/monolith-ui";
import { useTenantSettings } from "@/hooks/useTenantSettings";

export interface SettingEntity {
  id: number;
  uuid: string;
  setting: string;
  display_name: string;
  description: string;
  enabled: number;
}

interface Setting extends Partial<SettingEntity> {
  permission: string;
}

const SettingSwitchGroup = styled(
  ({ className, title, handleOptionChange, settings }) => {
    const { hasPermission } = usePermissions();
    const { tenantSettings } = useTenantSettings();

    return (
      <div className={className}>
        <div
          style={{ fontSize: "large", fontWeight: "bold", marginBottom: 20 }}
        >
          {title}
        </div>
        <div className="setting-options">
          {settings.map((s: Setting) => {
            const setting = tenantSettings.find(
              (setting: SettingEntity) => setting.setting === s.setting
            );
            if (!setting) return null;
            return (
              <div className="setting-option">
                <Switch
                  size="xs"
                  defaultValue={setting?.enabled === 1}
                  onChange={(value) => handleOptionChange(setting, value)}
                  disabled={!hasPermission(s.permission)}
                />
                <div data-disabled={!hasPermission(s.permission)}>
                  {setting?.description}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
)`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  overflow-y: auto;

  .setting-options {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-left: 20px;

    &[data-disabled="true"] {
      opacity: 0.5;
      pointer-events: none;
    }
  }

  .setting-option {
    display: flex;
    flex-direction: row;
    gap: 15px;
    align-items: center;
    font-weight: 500;
    color: ${({ theme }) => theme.palette.text.secondary};
    user-select: none;
  }
`;

export default SettingSwitchGroup;
